/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingsEventCompletionFinalizeParams } from './meetingsEventCompletionFinalizeParams';

/**
 * Request model for meetings event completion finalize job
 */
export interface RunMeetingsEventCompletionFinalizeJobRequest {
  type: 'meetings_event_completion_finalize';
  params: MeetingsEventCompletionFinalizeParams;
  allowOverlappingJobs?: boolean;
}
